@if (isFeatureFlagManagerEnabled) {
  <app-feature-flag-manager />
}

<router-outlet />
